import { Modal, ModalBody } from "shared/UI/Modal/Modal";
import useLocale, { ManualLocales } from "core/hooks/useLocale/useLocale";
import { t } from "i18next";
import { useModalContext } from "shared/core/state/ModalContext/ModalContext";
import { trackBtnClicks, trackEvents } from "core/monitoring/Events";
import { Select } from "shared/UI/Select/Select";
import { EventNames } from "core/monitoring/types/enums";

interface LocaleOptionProps {
  handleLocaleClick: (locale: ManualLocales) => void;
  hideDefault?: boolean;
}

export const LocaleOption = (props: LocaleOptionProps) => {
  const { handleLocaleClick, hideDefault } = props;
  return (
    <Select
      onChange={(e) => handleLocaleClick(e.target.value as ManualLocales)}
      label="Select Location"
      defaultValue={!hideDefault ? "en" : undefined}
    >
      {hideDefault && <option />}
      <option value={"en"}>{t("localeModel.options.uk")}</option>
      <option value={"en_AU"}>{t("localeModel.options.au")}</option>
      <option value={"en_NZ"}>{t("localeModel.options.nz")}</option>
    </Select>
  );
};

export const LocaleModal = () => {
  const { isVisible } = useModalContext("localeModal");
  const { localeId, updateLocale } = useLocale();

  const dismissAction = (locale: ManualLocales = "en") => {
    trackEvents(EventNames.MANUAL_LOCALE_SELECT);
    trackBtnClicks(`locale-selected-${locale}`);
    updateLocale(locale);
    window.location.reload();
  };

  return (
    <>
      {isVisible && !localeId && (
        <Modal title={t("localeModel.title")} width="xs" hideDismiss={true} bgDismiss={false}>
          <ModalBody>
            <LocaleOption handleLocaleClick={dismissAction} hideDefault />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
